import { useState } from "react";
import { Play } from "lucide-react";
import { streamUrl } from "@/lib/videoStream";

// Click-to-load video: nothing is fetched from the backend until the user
// clicks play. Prevents many <video> elements from loading the whole file
// concurrently (which previously caused OOM/520 in production).
export default function LazyVideo({ vid, testId }) {
  const [active, setActive] = useState(false);

  if (active) {
    return (
      <video
        controls
        autoPlay
        playsInline
        preload="none"
        className="w-full h-full"
        src={streamUrl(vid)}
        data-testid={testId}
      />
    );
  }

  return (
    <button
      type="button"
      onClick={() => setActive(true)}
      className="group w-full h-full flex flex-col items-center justify-center gap-2 text-white/80 hover:text-white transition-colors"
      data-testid={testId ? `${testId}-load` : `video-load-${vid}`}
    >
      <span className="w-14 h-14 rounded-full bg-white/10 group-hover:bg-white/20 flex items-center justify-center transition-colors">
        <Play className="w-6 h-6 ml-0.5" fill="currentColor" />
      </span>
      <span className="text-xs font-medium">Click to load video</span>
    </button>
  );
}
